import request from "../../helpers/request";

export const getPontosMonitoriaGeral = async (
  idLoja: string,
  idCliente: string,
  apiKey?: string,
) => {
  const lojaParam = idLoja ? idLoja : "0";
  console.log(
    `Buscando pontos de monitoramento geral para a loja ${lojaParam} e cliente ${idCliente}...`,
  );
  const url = `${process.env.REACT_APP_API}/Hub/GrupoMonitor/PtosMonitorGeral/${lojaParam}/${idCliente}`;
  const result = await request({ url, apiKey });

  console.log(`Pontos de monitoramento recebidos:`, result.data);

  return result.data;
};
